import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import React__default, { useMemo, useEffect } from 'react';
import { usePopupState, bindTrigger, bindFocus, bindMenu } from 'material-ui-popup-state/hooks';
import { styled } from '@mui/material';
import clsx from 'clsx';
import CascadingMenu from './components/CascadingMenu.js';
import OverflowProvider from './OverflowProvider.js';

const _CascadingMenu = styled(CascadingMenu) `
  pointer-events: auto !important;
`;
const OverflowWindow = (_a) => {
    var { dense = false, children, target, id = 'overflowWindow', 'data-testid': testId, onToggle } = _a, rest = __rest(_a, ["dense", "children", "target", "id", 'data-testid', "onToggle"]);
    const popupState = usePopupState({
        popupId: id,
        variant: 'popover',
        disableAutoFocus: true,
    });
    const targetElement = useMemo(() => {
        var _a;
        const _b = bindTrigger(popupState), { onClick } = _b, triggetData = __rest(_b, ["onClick"]);
        return React__default.cloneElement(target, Object.assign(Object.assign(Object.assign({}, triggetData), (!((_a = target.props) === null || _a === void 0 ? void 0 : _a.disabled) ? bindFocus(popupState) : undefined)), { className: popupState.isOpen ? clsx(target.props.className, 'overflow-target-open') : target.props.className, onClick: (e) => {
                e.stopPropagation();
                onClick(e);
            } }));
    }, [target, popupState]);
    useEffect(() => {
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(popupState.isOpen);
    }, [onToggle, popupState.isOpen]);
    return (jsxs(OverflowProvider, Object.assign({ dense: dense, rootPopupState: popupState }, { children: [targetElement, jsx(_CascadingMenu, Object.assign({ "data-testid": testId }, rest, { popupState: popupState }, bindMenu(popupState), { children: children }))] })));
};

export { OverflowWindow as default };
//# sourceMappingURL=OverflowWindow.js.map
